export interface IPowerItem {
    observed: number,
    model: number
}

export interface IPower {
    [key: string]: IPowerItem[]
}

export const power: IPower = {
    'WTG000': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG001': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 600,
            'model': 500,
        }
    ],
    'WTG002': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG003': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG004': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG005': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG006': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG007': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG008': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG009': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG010': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG011': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG012': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG013': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG014': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG015': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG016': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG017': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG018': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG019': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG020': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG021': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG022': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG023': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG024': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG025': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG026': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG027': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG028': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG029': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG030': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG031': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG032': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG033': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG034': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG035': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG036': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG037': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG038': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG039': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG040': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG041': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG042': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG043': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 500,
            'model': 600,
        }
    ],
    'WTG044': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG045': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG046': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG047': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG048': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG049': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG050': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG051': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG052': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG053': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG054': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG055': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG056': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG057': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG058': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG059': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG060': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG061': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG062': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG063': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG064': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG065': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG066': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG067': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG068': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG069': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG070': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
    'WTG071': [
        {
            'observed': 300,
            'model': 300,
        },
        {
            'observed': 400,
            'model': 500,
        }
    ],
}
